import { useSelector } from 'react-redux';

import { getSingleDiffExpansion } from 'src/redux/pull-request/selectors';

type DiffExpansionStateParams = {
  filepath: string;
};

export const useDiffExpansionState = ({ filepath }: DiffExpansionStateParams) =>
  useSelector(state => getSingleDiffExpansion(state, filepath));
